import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE = `${u}/note`;

export const getLinks    = (noteId) => apiFetch(`${BASE}/${noteId}/links`).then(r => r.ok ? r.json() : []);
export const getBacklinks = (noteId) => apiFetch(`${BASE}/${noteId}/backlinks`).then(r => r.ok ? r.json() : []);
export const addLink     = (noteId, targetId) => apiFetch(`${BASE}/${noteId}/links/${targetId}`, { method: "POST" }).then(r => r.json());
export const removeLink  = (noteId, targetId) => apiFetch(`${BASE}/${noteId}/links/${targetId}`, { method: "DELETE" });
